import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AppDispatch } from '../../state';
import { ApplicationModal, setOpenModal } from '../../state/application/actions';

// Redirects to swap but only replace the pathname
export function RedirectPathToLimitOnly({ location }: RouteComponentProps) {
  return <Redirect to={{ ...location, pathname: '/limit' }} />;
}

// Redirects from the /limit/:outputCurrency path to the /limit?outputCurrency=:outputCurrency format
export function RedirectToLimit(props: RouteComponentProps<{ outputCurrency: string }>) {
  const {
    location: { search },
    match: {
      params: { outputCurrency },
    },
  } = props;

  return (
    <Redirect
      to={{
        ...props.location,
        pathname: '/limit',
        search:
          search && search.length > 1
            ? `${search}&outputCurrency=${outputCurrency}`
            : `?outputCurrency=${outputCurrency}`,
      }}
    />
  );
}

export function OpenClaimAddressModalAndRedirectToLimit(props: RouteComponentProps) {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(setOpenModal(ApplicationModal.ADDRESS_CLAIM));
  }, [dispatch]);
  return <RedirectPathToLimitOnly {...props} />;
}
